/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGrid3x3 = createReactComponent("outline", "grid-3x3", "IconGrid3x3", [["path", { "d": "M3 8h18", "key": "svg-0" }], ["path", { "d": "M3 16h18", "key": "svg-1" }], ["path", { "d": "M8 3v18", "key": "svg-2" }], ["path", { "d": "M16 3v18", "key": "svg-3" }]]);

export { IconGrid3x3 as default };
//# sourceMappingURL=IconGrid3x3.mjs.map
